"use strict";

document.addEventListener("DOMContentLoaded", function () {
  /**
   * Hook into field registration events
   * The nb:registered event is fired on the body every time
   * _nb.fields.registerListener is called and during page load for
   * each field auto registered.
   *
   * All `nb:` prefixed events contain a `detail` object
   * with the following params:
   *   `id` - a reference ID for the field & form
   *   `result` - a result object
   *   `error` - error object from request
   */
  document.querySelector('body').addEventListener('nb:registered', function (event) {
    // Get field using id from registered event
    var field = document.querySelector("[data-nb-id=\"".concat(event.detail.id, "\"]"));
    var currentVal = field.value;

    // Skip fields with disabled validation.
    if (field.classList.contains("validation-off")) {
      // Unregister the field with the widget
      setTimeout(function () {
        _nb.fields.unregisterListener(field);
      }, 1000);
      return;
    }
    var form = field.closest('form');
    var isRequired = field.hasAttribute("required");
    var submit = form.querySelector("[type=\"button\"], [type=\"submit\"], button");
    var enableSubmit = function enableSubmit() {
      submit.removeAttribute("disabled");
    };
    var disableSubmit = function disableSubmit() {
      if (isRequired && currentVal !== field.value) {
        submit.setAttribute("disabled", "");
      }
      currentVal = field.value;
    };

    // Disable submit button if email is required.
    disableSubmit();

    // Handle field change.
    field.addEventListener("change", function (e) {
      disableSubmit();
    });

    // Handle clear events (input has changed or an API error was returned)
    field.addEventListener("nb:clear", function (e) {
      // Check for errors
      if (e.detail.result && e.detail.result.isError()) {
        if (e.detail.result.isThrottled()) {
          // Do stuff when the verification is throttled
        }

        // Do stuff when other API errors occur
        // - Our recommendation is to hide any loaders and treat these emails the same way you would treat an Unknown email
        // Disable submit button if email is required.
        disableSubmit();
      }

      // Do stuff when input changes, (e.g. hide loader)
    });

    // Handle loading status (API request has been made)
    field.addEventListener("nb:loading", function (e) {
      // Do stuff while waiting on API response
      disableSubmit();
    });

    // Handle results (API call has succeeded)
    field.addEventListener("nb:result", function (e) {
      if (e.detail.result.is(_nb.settings.getAcceptedStatusCodes())) {
        // Do stuff for good email
        enableSubmit();
      } else {
        // Do stuff for bad email
        disableSubmit();
      }
    });

    // Handle soft results (fails regex; doesn't bother making API request)
    field.addEventListener("nb:soft-result", function (e) {
      // Do stuff when input doesn't even look like an email (i.e. missing @ or no .com/.net/etc...)
      disableSubmit();
    });
  });
});
"use strict";

$(document).ready(function () {
  $('.faqs .faq .question').click(function () {
    $(this).closest('.faq').toggleClass("active");
  });
});
"use strict";

// NOTE: This script should never be called from a template. It exists only to be called from the shopify settings associated with the GA script.
// GTM Script
(function (w, d, s, l, i) {
  w[l] = w[l] || [];
  w.pathJsCallOrder.push('GTM script called');
  // gtm.start was already called from the theme.liquid 
  // template so it's omited here.
  w[l].push({
    event: 'gtm.js'
  });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s);
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i;
  f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-K97CP6W');
"use strict";

$(document).ready(function () {
  // Initialize MMenu.
  var mmenu = new Mmenu("#header-menu", {
    slidingSubmenus: false,
    navbar: {
      add: false
    },
    navbars: {
      content: ['<a href="#page" id="mmenu-close"><span></span></a>']
    }
  }, {
    // configuration
    offCanvas: {
      clone: true
    },
    panelNodetype: ['nav', 'ul']
  });

  //document.addEventListener('closeMMenu', () => {
  $(document).on('closeMMenu', function () {
    mmenu.API.close();
  });
});
"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
$(document).ready(function () {
  var popupBodyStyles = {
    'top': '0',
    'position': 'fixed',
    'width': '100%'
  };

  // $(window).on('click', function () {
  //     closeAllPopups();
  // });

  $('.popup-user-form .inner .open-popup').on('click', function (e) {
    openLinkPopup(e, $(this));
  });
  $(document).on('click', '.open-popup', function (e) {
    openLinkPopup(e, $(this));
  });
  var urlParams = new URLSearchParams(window.location.search.replace(/^\?/, ''));
  var $submittedPopupForm;
  if (urlParams.get('form_type') === 'customer' || urlParams.get('customer_posted') === 'true') {
    if (window.location.hash) {
      $submittedPopupForm = $('.cta-popup-form[data-form-id="' + window.location.hash.replace(/^#/, '') + '"]').first();
    }
  }
  if ($submittedPopupForm && $submittedPopupForm.length) {
    // If the newsletter signup popup has been submitted, set cookie not to show it again.
    if ($submittedPopupForm.attr('id') === 'newsletter-signup-popup') {
      Cookies.set('newsletter-signup-popup', '1', {
        expires: 365
      });
    }

    // Show confirmation popup.
    var $confirmationPopup = $submittedPopupForm.parent('form').next('.cta-popup-confirmation');
    openPopup($confirmationPopup);

    // Download file if it's file download popup that is submitted.
    if ($submittedPopupForm.hasClass('file-download-popup')) {
      // Handle download link if any.
      var downloadLink = $confirmationPopup.find('.insert-download-link').get(0);
      if (downloadLink.classList.contains('download-link-processed')) {
        downloadLink.click();
      } else {
        fetch(downloadLink.href).then(function (response) {
          return response.blob();
        }).then(function (blob) {
          downloadLink.download = getFileName(downloadLink.href);
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.classList.add('download-link-processed');
          downloadLink.click();
        });
        var getFileName = function getFileName(url) {
          var _url$split = url.split('?'),
            _url$split2 = _slicedToArray(_url$split, 1),
            cleanUrl = _url$split2[0];
          return decodeURIComponent(cleanUrl.split('/').pop());
        };
      }
    }
  }
  // If no popups have been submitted, maybe we should show the newsletter popup.
  // else if (!Cookies.get('newsletter-signup-popup')) {
  //     setTimeout(function () {
  //         if ($('.popup-user-form:visible').length === 0) {
  //             openPopup('#newsletter-signup-popup')
  //         }
  //     }, 10000);
  // }

  // Open download popups.
  $('.insert-download-card .btn').click(function (event) {
    // Don't propagate click to prevent closing the popup.
    event.stopPropagation();

    // Prevent processing anchor as anchor.
    event.preventDefault();
    openPopup($(this).parents('.insert-download').find('.cta-popup-form'));
  });
  $('.popup-user-form .inner').on('click', function (event) {
    // Don't propagate click to prevent closing the popup.
    event.stopPropagation();
  });
  $('.popup-user-form').find('.close, .close-btn').on('click', function (event) {
    closePopup(event, $(this));
  });
  function openLinkPopup(event, $link) {
    // Don't propagate click to prevent closing the popup.
    event.stopPropagation();

    // Prevent processing anchor as anchor.
    event.preventDefault();
    openPopup('#' + $link.data('target'));
  }
  function openPopup(selector) {
    var $popup = $(selector);
    if ($popup.length === 0) {
      return;
    }
    var windowScrollY = window.scrollY;

    // Close the mobile menu
    $(document).trigger('closeMMenu');

    // Close all popups.
    closeAllPopups();

    // Open targeted popup.
    $popup.fadeIn(200);

    // Fix body position.
    // NOTE: Ensure 'top' property is always processed before the 'position' property
    Object.keys(popupBodyStyles).forEach(function (styleName) {
      document.body.style[styleName] = popupBodyStyles[styleName];
    });

    // Set body scroll position
    if (windowScrollY) {
      popupBodyStyles.top = "-".concat(windowScrollY, "px");
      document.body.style.top = popupBodyStyles.top;
      $popup.css('top', windowScrollY);
    }
  }
  function closePopup(event, $link) {
    // If the closed popup is newsletter signup, set cookie not to show it again.
    if ($link.parents('#newsletter-signup-popup').length) {
      Cookies.set('newsletter-signup-popup', '1', {
        expires: 365
      });
    }

    // See if this is the only open popup, and if so, run
    // closeAllPopups() instead so that original body styles
    // are restored.
    if ($('.popup-user-form:visible').length < 2) {
      return closeAllPopups();
    }

    // Close the targeted popup
    $link.parents('.popup-user-form').fadeOut(200);
  }
  function closeAllPopups() {
    $('.popup-user-form:visible').fadeOut(200);

    // Restore windows scroll position.
    if (document.body.style.position === 'fixed') {
      // string like "-980px"
      // const scrollY = document.body.style.top;

      // Restore original body poisition.
      // NOTE: Ensure 'top' property is always processed before the 'position' property
      Object.keys(popupBodyStyles).forEach(function (styleName) {
        document.body.style[styleName] = '';
      });
      window.scrollTo(0, parseInt(popupBodyStyles.top || '0') * -1);
    }
  }
});
"use strict";

/*
 * File: site-search.js                                                        *
 * Project: pathedits.com                                                      *
 * Created Date: 2022-02-18                                                    *
 * -----                                                                       *
 * Last Modified: Fri Feb 18 2022                                              *
 * Modified By: Shelton Koskie                                                 *
 * -----                                                                       *
 * Copyright (c) 2022 Eighty Grit                                              *
 * -----                                                                       *
 * CHANGE LOG:                                                                 *
 * Date      	By	Comments                                                     *
 * ----------	---	---------------------------------------------------------    *
 */

document.addEventListener('DOMContentLoaded', function () {
  ['site-search-open', 'site-search-open-mobile'].forEach(function (id) {
    var opener = document.getElementById(id);
    opener.addEventListener('click', function (event) {
      document.getElementsByTagName('body').item(0).classList.add('modal-open');
      var modal = document.getElementById('site-search-modal');
      modal.classList.add('active');
      modal.querySelector('input').focus();
      event.stopPropagation();
      event.preventDefault();
    });
  });
  var closer = document.getElementById('site-search-close');
  closer.addEventListener('click', function (event) {
    var modal = document.getElementById('site-search-modal');
    document.getElementsByTagName('body').item(0).classList.remove('modal-open');
    modal.classList.remove('active');
    event.stopPropagation();
    event.preventDefault();
  });
});
"use strict";

document.addEventListener('DOMContentLoaded', function (event) {
  document.documentElement.classList.replace('no-js', 'js');
});

// Sticky header on scroll
document.addEventListener('scroll', function (e) {
  var header = document.getElementById('page-header');
  if (window.scrollY == 0) {
    return header.classList.replace('sticky', 'sticky-at-top');
  }
  if (header.classList.contains('sticky') === false) {
    header.classList.replace('sticky-at-top', 'sticky');
  }
});
"use strict";

$(document).ready(function () {
  var $carousel = $('.section--testimonials-carousel');
  if (!$carousel.length) {
    return;
  }
  $.ajax({
    url: $carousel.data('source-url'),
    cache: true,
    dataType: 'json',
    success: function success(data, textStatus, jqXHR) {
      var $container = $carousel.find('.testimonials');
      $.each(data, function (index, item) {
        $container.append('<li class="testimonial glide__slide">' + '  <div class="text">' + item.content + '</div>' + '  <div class="author">' + '    <div class="name">' + item.customer_name + '</div>' + '    <div class="place">' + item.location + '</div>' + '  </div>' + '</li>');
      });
      var animationDuration = 400;
      var glide = new Glide('.section--testimonials-carousel .glide', {
        type: 'carousel',
        gap: 24,
        perView: 3.2,
        animationDuration: animationDuration,
        autoplay: 4000,
        hoverpause: true,
        breakpoints: {
          1800: {
            perView: 2.2
          },
          1400: {
            perView: 1.2
          }
        }
      });
      glide.on('move', function () {
        var index = glide.index % 4;
        $carousel.addClass('glide-moving').attr('data-slide-start', index);
        setTimeout(function () {
          $carousel.attr('data-slide-end', index);
          setTimeout(function () {
            $carousel.removeClass('glide-moving');
          }, animationDuration / 4);
        }, animationDuration / 4);
      });
      glide.mount();
    },
    error: function error(data, textStatus, errorThrown) {
      console.error(errorThrown);
    }
  });
});